module.exports = function() {
  return new Worker(__webpack_public_path__ + "9929e5979d65a192c6fb.worker.js");
};